module.exports = __webpack_public_path__ + "img/logo-cbi.2addb91ff3947ba5cfef8e9dc6c28982.png";